export function formatDateTime(dateObject: Date, string: boolean) {
    const pad = (value: number) => (value < 10 ? '0' + value : value);

    const year = dateObject.getFullYear();
    const month = pad(dateObject.getMonth() + 1);
    const day = pad(dateObject.getDate());
    const hours = pad(dateObject.getHours());
    const minutes = pad(dateObject.getMinutes());
    if (string) {
      return `${day}.${month}.${year} ${hours}:${minutes}`;
    }
    return {
      year,
      month,
      day,
      hours,
      minutes,
    };
  };

export function isDateNotLaterThanToday(date: Date) {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const endOfDay = new Date(currentDate);
  endOfDay.setHours(23, 59, 59, 999);
  return date <= endOfDay;
}

export function isDateNotEarlierThanToday(date: Date) {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  return date >= currentDate;
}